t = require('app/scripts/views/internal/teacup-with-helpers')('card_attach_links')

module.exports = t.renderable (links) ->
  t.div '.card-attach-link-list', ->
    for { url, text, domain, attached } in links
      t.div '.card-attach-link-list-item', { class: t.classify(attached: attached) }, ->
        t.div '.card-attach-link-list-item-title', ->
          if text
            t.text text
          else
            t.format 'link to domain', { domain }

        t.div '.card-attach-link-list-item-url.quiet', ->
          t.text url

        if !attached
          t.button '.card-attach-link-list-item-attach.js-attach', { 'data-url': url, 'data-text': text }, ->
            t.format 'attach'
        else
          t.div '.card-attach-link-list-item-attached.quiet', ->
            t.span '.icon-lg.icon-check'
